import { render, staticRenderFns } from "./weight-input.vue?vue&type=template&id=424b2250&"
import script from "./weight-input.vue?vue&type=script&lang=ts&"
export * from "./weight-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports